import moment from "moment";
import {montShortNameList, TimeFormat} from "./enum";
import {CampaignBigType} from "../views/campaign/dataForActiveCampaign";

// Match date string with HH:mm format.
export const validateHHmm = (dateTime: string) => {
    return /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/gm.test(dateTime)
}

export const formatDateTimeToAMPM = (dateTime: string) => {
    // 24h
    if (!validateHHmm(dateTime)) {
        return ""
    }
    const hour = parseInt(dateTime)
    const min = dateTime.slice(3, 5)
    if (hour < 12) {
        return (hour < 10 ? "0" : "") + hour + ":" + min + " " + "AM"
    }
    let prefix: string
    if (hour === 12) {
        prefix = "12"
    } else if (hour - 12 < 10) {
        prefix = "0" + (hour - 12)
    } else {
        prefix = (hour - 12).toString()
    }
    return prefix + ":" + min + " " + "PM"
}

export const convertUTCtoLocal = (dateStringUTC: string) => {
    return moment(dateStringUTC).format(TimeFormat.YYYYMMDDHHmmss)
}

export const convertUTCToLocalMoment = (dateUTC: string) => {
    const date = new Date(dateUTC)
    return moment(date)
}

export const formatDateTime = (date: string, campaignBigType: CampaignBigType = CampaignBigType.regularCampaign) => {
    const m = convertUTCToLocalMoment(date)
    const formatDateTime = formatDateTimeToAMPM(m.format(TimeFormat.YYYYMMDDHHmmss).slice(11, 16))
    if (campaignBigType === CampaignBigType.automatedCampaign) {
        return `Daily ${formatDateTime}`
    }
    const month = montShortNameList[m.month()]
    const day = m.date()
    const year = m.year()
    const dayString = day >= 10 ? day.toString() : "0" + day
    return `${month} ${dayString}, ${year} ${formatDateTime}`
}

export const formatDate = (date: string | Date) => {
    const m = typeof date === "string" ? moment(date, TimeFormat.YYYYMMDDHHmmss) : moment(date)
    const month = montShortNameList[m.month()]
    const day = m.date()
    const year = m.year()
    const dayString = day >= 10 ? day.toString() : "0" + day
    return `${month} ${dayString}, ${year}`
}

export const formatDoctorName = (firstName: string, lastName: string): string => {
    const first = firstName ? firstName.trim() : ""
    const last = lastName ? lastName.trim() : ""
    return `${first}${first.length && last.length ? " " : ""}${last}`
}

export const check3DigitalNumber = (numberString: string) => {
    return /^\d{1,3}$/.test(numberString)
}

export const insertToArray = <T>(list: T[], idx: number, newItem: T) => [
    ...list.slice(0, idx),
    newItem,
    ...list.slice(idx),
];

export const differ = (action: () => void, duration?: number) => {
    return setTimeout(action, duration || 500)
}

const str2UTF8 = (str: string) => {
    let bytes = [];
    let len, c;
    len = str.length;
    for (let i = 0; i < len; i++) {
        c = str.charCodeAt(i);
        if (c >= 0x010000 && c <= 0x10FFFF) {
            bytes.push(((c >> 18) & 0x07) | 0xF0);
            bytes.push(((c >> 12) & 0x3F) | 0x80);
            bytes.push(((c >> 6) & 0x3F) | 0x80);
            bytes.push((c & 0x3F) | 0x80);
        } else if (c >= 0x000800 && c <= 0x00FFFF) {
            bytes.push(((c >> 12) & 0x0F) | 0xE0);
            bytes.push(((c >> 6) & 0x3F) | 0x80);
            bytes.push((c & 0x3F) | 0x80);
        } else if (c >= 0x000080 && c <= 0x0007FF) {
            bytes.push(((c >> 6) & 0x1F) | 0xC0);
            bytes.push((c & 0x3F) | 0x80);
        } else {
            bytes.push(c & 0xFF);
        }
    }
    return bytes;
}

export const getSmsMessageLength = (message: string): number => {
    if (!message) {
        return 0
    }
    const asciiLength = message.length
    const utf8Length = str2UTF8(message).length
    return Math.floor(asciiLength + (utf8Length - asciiLength) / 2)
}

export const formatPhone = (phone: string): string => {
    if (/^\d{3}-\d{3}-\d{4}$/.test(phone)) {
        return phone
    }
    phone = phone.replaceAll(/\D/ig, "")
    if (/^\d{10}$/.test(phone)) {
        return `${phone.substring(0, 3)}-${phone.substring(3, 6)}-${phone.substring(6)}`
    }
    return phone
}
